import { Navigate } from 'react-router'
import type { JSX } from 'react'
import { useWizard } from './context'
import { pathFor } from './steps'

/**
 * `/onboarding` — sends the tenant to wherever they actually are.
 *
 * **This is what "resume exactly there" means in the router.** The cursor lives
 * in the tenant's schema, not in the URL and not in the SPA, so a browser that
 * has never seen this organisation before lands on the step the last one left
 * off at. A finished wizard goes to the summary rather than back to step 1.
 *
 * `replace`, so the browser Back button leaves the wizard rather than bouncing
 * between this redirect and the step it just chose.
 */
export function OnboardingIndex(): JSX.Element {
  const state = useWizard()
  if (state.completed_at) return <Navigate to="/onboarding/done" replace />
  return <Navigate to={pathFor(state.current_step)} replace />
}
